import "./Type.css";
import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { Autocomplete, TextField } from "@mui/material";
import { MultipleQueryTypesense } from "../../../../Typesense";
import { getLocalStorageItem } from "../../../../controllers/localStorage/getLocalStorage";
import PropertiesContent from "../../../Properties/PropertiesContent/PropertiesContent";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import CustomSelect from "../../../../components/Common/CustomSelect/CustomSelect";
import GetAllProperties from "../../../../controllers/properties/GetAllProperties";
import Select from "react-select";

const Type = ({
  campaignTitle,
  setCampaignTitle,
  campaignType,
  setCampaignType,
  campaignSource,
  setCampaignSource,
  property,
  setProperty,
  propertyError,
  setPropertyError,
  campaignTitleError,
  setcampaignTitleError,
  date,
}) => {
  const [inputSearch, setInputSearch] = useState("");
  const [localProperties, setLocalProperties] = useState([]);
  const [modalStatus, setModalStatus] = useState(false);
  const [isPropertySelected, setIsPropertySelected] = useState(false);

  console.log("property", property);
  useEffect(() => {}, [campaignSource]);
  // useEffect(() => {
  //   if (property) {
  //     setIsPropertySelected(true);
  //   } else {
  //     setIsPropertySelected(false);
  //   }
  // }, []);

  // useEffect(() => {
  //   async function fetchPropertiesTypsenseWithSearch() {
  //     let properties = (
  //       await MultipleQueryTypesense(
  //         {
  //           searches: [
  //             {
  //               q: inputSearch,
  //               query_by: "propertyTitle",
  //               filter_by: `bid:=${getLocalStorageItem(
  //                 "bid"
  //               )} && is_deleted:=false`,
  //             },
  //             {
  //               q: inputSearch,
  //               query_by: "propertyTitle",
  //               filter_by: `sharedParties:=[${getLocalStorageItem(
  //                 "bid"
  //               )}] && is_deleted:=false`,
  //             },
  //           ],
  //         },
  //         {
  //           collection: "properties",
  //         }
  //       )
  //     ).map(({ document }) => document);
  //     setLocalProperties([...properties]);
  //   }

  //   fetchPropertiesTypsenseWithSearch();
  // }, [inputSearch]);

  useEffect(() => {
    async function fetchData() {
      if (inputSearch.length > 0) {
        const array = [];
        for (let i = 0; i < localProperties.length; i++) {
          if (
            localProperties[i].name
              .toLowerCase()
              .includes(inputSearch.toLowerCase())
          ) {
            array.push(localProperties[i]);
          }
        }
        setLocalProperties(array);
      } else {
        const prop = await GetAllProperties();

        setLocalProperties(prop);
      }
    }
    fetchData();
  }, [inputSearch]);
  return (
    <div>
      <div className="marketing-input-main">
        <label className="form-field-label" htmlFor="text">
          Campaign Title
        </label>

        <input
          value={campaignTitle}
          onChange={(e) => {
            setCampaignTitle(e.target.value);
            if (e.target.value.length === 0) {
              setcampaignTitleError(true);
            } else {
              setcampaignTitleError(false);
            }
          }}
          className="form-control form-input-field"
          type="text"
          maxLength={"30"}
        />
        {campaignTitleError && (
          <label className="custom-error-message" htmlFor="text">
            Campaign Title is required
          </label>
        )}
      </div>
      <div className="marketing-input-main">
        <label className="form-field-label" htmlFor="text">
          Campaign Type
        </label>

        {/* <select
          className="form-control form-input-field"
          id="campaign-type"
          value={campaignType}
          onChange={(e) => {
            setCampaignType(e.target.value);
          }}
        >
          <option value={"Scheduled"}>Scheduled</option>
          <option value={"Now"}>Now</option>
        </select> */}

        <Select
          options={[{ value: "Now", label: "Now" }]}
          defaultValue={{ value: "Now", label: "Now" }}
          onChange={(e) => {
            setCampaignType(e.value);
          }}
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              border: "0px",
              background: "var(--theme-color-light)",
              outline: "none",
              boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.25)",
              // width: "200px",
              padding: "1px 0px",
            }),
          }}
        />
      </div>

      <div className="marketing-input-main">
        <label className="form-field-label" htmlFor="text">
          Campaign Source
        </label>
        {/* <select
          className="form-control form-input-field"
          value={campaignSource}
          onChange={(e) => {
            setCampaignSource(e.target.value);
            if (campaignTitle.includes("Marketing Campaign") === true) {
              setCampaignTitle(e.target.value + " Marketing Campaign " + date);
            }
          }}
        >
          <option value={"Email"}>Email</option>
          <option value={"WhatsApp"}>WhatsApp</option>
        </select> */}

        <Select
          options={[{ value: "Email", label: "Email" }]}
          defaultValue={{ value: "Email", label: "Email" }}
          onChange={(opt) => {
            setCampaignTitle(opt.value + " Marketing Campaign " + date);
          }}
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              border: "0px",
              background: "var(--theme-color-light)",
              outline: "none",
              boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.25)",
              // width: "200px",
              padding: "1px 0px",
            }),
          }}
        />
      </div>

      <div className="marketing-input-main">
        <div className="property-label-change-container">
          <label className="form-field-label" htmlFor="text">
            Property
          </label>

          {property && (
            <Box
              sx={{
                cursor: "pointer",
              }}
              onClick={() => {
                setIsPropertySelected(false);
                setProperty(null);
              }}
            >
              <CancelRoundedIcon
                sx={{
                  color: "#b51d1d",
                }}
              />
            </Box>
          )}
        </div>

        {property !== null ? (
          <div>
            <PropertiesContent property={property} isAddDeal={true} />
          </div>
        ) : (
          <Autocomplete
            style={{
              backgroundColor: "var(--theme-color-light)",
            }}
            className="campaign-property-select"
            disablePortal
            open={modalStatus}
            onOpen={() => setModalStatus(true)}
            onClose={() => setModalStatus(false)}
            id="combo-box-demo"
            options={localProperties}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            onChange={(event, value, reason, details) => {
              setIsPropertySelected(true);
              setProperty(value);
              if (!property) {
                setModalStatus(false);
                setPropertyError(false);
              } else {
                setModalStatus(true);

                setPropertyError(true);
              }
            }}
            getOptionLabel={(option) => option.propertyTitle ?? ""}
            defaultValue={!property ? null : property}
            onInputChange={(e, newInputValue) => {
              setInputSearch(newInputValue);
            }}
            inputValue={inputSearch ?? ""}
            renderInput={(params) => (
              <TextField
                {...params}
                label=""
                hiddenLabel
                value={inputSearch ?? ""}
                // id="outlined-basic"
                // variant="outlined"
              />
            )}
            renderOption={(props, option) => {
              // return <div {...props}>{option.propertyTitle}</div>;
              return (
                <>
                  <Box
                    className="select-property-element"
                    {...props}
                    key={option.id}
                  >
                    <div className="element-left">
                      {option?.images.length ? (
                        <img
                          src={option.images[0]}
                          className="property-select-img"
                          width={40}
                          height={40}
                          style={{
                            borderRadius: "7px",
                          }}
                        />
                      ) : (
                        <img
                          src={
                            "http://localhost:4000/static/media/loadingImg.bb9a6f7e052abd552a1f.gif"
                          }
                          width="40"
                          height="45"
                          className="icon"
                        />
                      )}
                    </div>
                    <div className="add-deal-property-element-right">
                      <p className="add-deal-property-title">
                        {option.propertyTitle}
                      </p>
                      <p className="add-deal-property-address">
                        {option.address}
                      </p>
                      <p className="add-deal-property-price">
                        {option?.availableForRent
                          ? option?.rentalPrice
                          : option?.sellingPrice}
                      </p>
                    </div>
                  </Box>
                  <div className="line"></div>
                </>
              );
            }}
          />
        )}
        {propertyError && (
          <label className="custom-error-message" htmlFor="text">
            Property is required
          </label>
        )}
      </div>
    </div>
  );
};

export default Type;
